<template>
<div id="top3">
    <div class="bg-color-black">
        <div class="cc-header">
            <dv-decoration-8 :color="['#2e6099', '#060711']" style="width:2rem;height:0.3rem;margin-left: 0.2rem;" />
            <div>闸机通行次数排行榜</div>
            <dv-decoration-8 :reverse="true" :color="['#2e6099', '#060711']" style="width:2rem;height:0.3rem;margin-right: 0.2rem;" />
        </div>
        <div class="d-flex jc-center">
            <dv-scroll-ranking-board :config="config" class="rankChart" />
        </div>
    </div>
</div>
</template>

<script>
var storage = window.localStorage;
var orgCode = storage.getItem("orgCode");
export default {
    data() {
        return {
            config: {}
        };
    },
    mounted() {
        this.initData();
        // 定时器刷新，1小时
        let _this = this;
        setInterval(() => {
            _this.initData(); // 修改数据date
        }, 1000 * 60 * 60);
    },
    methods: {
        initData() {
            let _this = this;
            this.$http.get("/dataView/gate/getPassRank?orgCode=" + orgCode).then(res => {
                if (res.data.code === 200) {
                    var config = {
                        data: res.data.result,
                        rowNum: 7, //表格行数
                        waitTime: 1000,
                        unit: "次" //数值单位
                    };
                    _this.config = config;
                }
            });
        }
    }
};
// function fontSize(res){
//     let clientWidth = window.innerWidth||document.documentElement.clientWidth||document.body.clientWidth;
//     if (!clientWidth) return;
//     let fontSize = 100 * (clientWidth / 1920);
//     return res*fontSize;
// }
</script>

<style lang="scss">
#top3 {
    height: 5.5rem;

    .cc-header {
        height: 0.75rem;
        color: #fff;
        font-size: 0.3rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .rankChart {
        width: 90%;
        height: 33vh;
		line-height: 0.22rem;
        .rank {width: 60px;font-size: 0.22rem;}
		.info-name{font-size: 0.22rem;}
		.ranking-value{font-size: 0.22rem;}
		.inside-column{height: 0.01rem;}
    }
}
</style>
